import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { ReelsService } from '../../../../services/reels.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { CreateEditReelComponent } from './create-edit-reel/create-edit-reel.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { ConfigMediasComponent } from './config-medias/config-medias.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ImportReelComponent } from './import-reel/import-reel.component';
import { ModalSize } from '../../../../shared/modal/models/modal.model';
import { CustomersService } from '../../../../services/customers.service';
import { ControlService } from '../../../../services/control.service';

@Component({
	selector: 'app-reels',
	templateUrl: './reels.component.html',
	styleUrls: ['./reels.component.scss']
})
export class ReelsComponent implements OnInit, OnDestroy {
	dtConfig = {
		config: {
			base: this.reelsService,
			api: 'datatable',
			rowsPerPage: 10,
			order: [[2, 'desc']],
			params: {
				key: '',
				client_id: null
			}, hasCustomProcessData: true,
			processValues: (response) => {
				response.data.map((unit: any) => {
					unit.client_name = this.clientesMap.get(unit.client_id) || 'Partner no asociado';
					return unit;
				});
				return response;
			}
		},
		columns: [
			{
				title: 'clave única',
				field: 'id'
			},
			{
				title: 'Name',
				field: 'name'
			},
			{
				title: 'Partner',
				field: 'client_name'
			},
			{
				title: 'Tipo',
				field: 'type'
			},
			{
				title: 'Grupo',
				field: 'group.name',
			}
		],
		actions: [
			{
				display: 'Videos',
				icon: 'fa-cogs',
				event: 'reels.config',
				conditionality: 'true'
			},
			{
				display: 'Editar',
				icon: 'fa-pencil',
				event: 'reels.edit',
				conditionality: 'true'
			},
			{
				display: 'Importar',
				icon: 'fa-clone',
				event: 'reels.import-medias',
				conditionality: 'true'
			},
			{
				display: 'Eliminar',
				icon: 'fa-trash',
				event: 'reels.delete',
				conditionality: 'true'
			},
			/* {
				display: 'Evidencias',
				icon: 'fa-file-image-o',
				event: 'reels.evidences',
				conditionality: 'true'
			}*/
		]
	};
	isAdmin: boolean = false;
	clientes: any[] = [];
	selectedClientId: number | null = null;
	canAddGroup: boolean = true;
	private atComponentDestroy = new Subject();
	private clientesMap = new Map<number, string>();

	constructor(
		private reelsService: ReelsService,
		private swal: SwalService,
		private broadcast: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private nrModal: NRModalService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private customerService: CustomersService,
		private controlService: ControlService
	) {

		if (this.activatedRoute.snapshot.params['id']) {
			this.dtConfig.config.params['filterById'] = this.activatedRoute.snapshot.params['id'];
		}
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.complete();
	}
	clearClientFilter(): void {
		this.selectedClientId = null;
		delete this.dtConfig.config.params.client_id;
		this.broadcast.reloadDataTable();
	}

	onClientChange(): void {
		if (this.selectedClientId) {
			this.dtConfig.config.params.client_id = this.selectedClientId;
		} else {
			delete this.dtConfig.config.params.client_id;
		}
		this.broadcast.reloadDataTable();
	}
	ngOnInit(): void {
		this.controlService.isAdmin().subscribe(res => {
			this.isAdmin = res.is_admin;
		});

		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				if (props) {
					this.nrModal.open(props, props.modalModel?.modalConfiguration?.modalSize || 'xl');
				}
			});
		this.customerService.datatable(1, {client_id: this.selectedClientId}).subscribe((res: any) => {
			if (res?.data) {
				this.clientes = res.data;

				res.data.forEach(cliente => {
					this.clientesMap.set(cliente.id, cliente.nombre_comercial ?? cliente.name);
				});

				this.broadcast.reloadDataTable();
			}
		});
		this.customerService.getLimits().then((res: any) => {
			const reelsLimit = res.reels || { used: 0, limit: 0 };
			this.canAddGroup = reelsLimit.used < reelsLimit.limit;
		});

	}

	/**
	 * Prepare the Reel data for the modal window
	 * @param event
	 * @returns
	 */
	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel;
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: event.data.item || {}
		};

		switch (event.name) {
			case 'reels.add':
				props.modalModel.component = CreateEditReelComponent;
				props.modalModel.modalConfiguration = {
					title: 'Agregar Reel'
				};
				props.modalModel.data = {
					is_admin: this.isAdmin
				};
				break;

			case 'reels.edit':
				props.modalModel.component = CreateEditReelComponent;
				props.modalModel.modalConfiguration = {
					title: 'Editar Reel'
				};
				props.modalModel.data = {
					is_admin: this.isAdmin,
					...event.data.item
				};
				break;

			case 'reels.config':
				props.modalModel.component = ConfigMediasComponent;
				props.modalModel.modalConfiguration = {
					title: 'Configurar Reel'
				};
				break;

			case 'reels.delete':
				this.delete(event.data);
				return false;
			case 'reels.import-medias':
				props.modalModel.component = ImportReelComponent;
				props.modalModel.modalConfiguration = {
					title: 'Importar Reel',
					modalSize: ModalSize.MD
				};
				break;
			case 'reels.evidences':
				this.router.navigate(['admin/svs/reel-evidences', event.data.item?.id]);
				return false;
		}

		return props;
	}

	/**
	 * Open ADD modal window
	 */
	add(): void {
		this.broadcast.fire({
			name: 'reels.add',
			type: EventType.MODAL,
			data: {}
		});
	}

	/**
	 * Get User confirmation and send the signal to the server
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: '¿Estás seguro de querer eliminar el reel?'
		};

		this.swal.warning(swalParams).then(result => {
			if (result.value) {
				this.reelsService.delete(data.item.id).subscribe((resp: any) => {
					if (resp.success) {
						this.swal.success({ title: 'Reel eliminado exitosamente' }).then(() => {
							this.broadcast.reloadDataTable();
						});
					} else {
						this.swal.error('Ocurrio un error al intentar borrar el Reel');
					}
				});
			}
		});
	}

}
